import { UserFindDto, type UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';

import * as yup from 'yup';

/** Cost center response body - DTO signature */
export interface CostCenterFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;
  /** Creation date and time */
  created: Date;
  /** Last update date and time */
  updated: Date;
  /** Soft deletion date and time. The cost center will be permanently deleted six months after this date. */
  deleted?: Date;
  /** The user who created this cost center */
  createdBy?: UserFindInterface;
  /** Cost center display name */
  name: string;
}

/** Cost center response body - DTO schema */
export const CostCenterFindDto = SerdeDtoClass.create<CostCenterFindInterface>(CatalogDtosKeysEnum.COST_CENTER_FIND_DTO, {
  id: {
    sortable: true,
    label: 'Номер',
    serializer: yup.number(),
  },
  created: {
    label: 'Создан',
    serializer: yup.date(),
  },
  updated: {
    label: 'Изменен',
    serializer: yup.date(),
  },
  deleted: {
    optional: true,
    label: 'Удален',
    serializer: yup.date(),
  },
  createdBy: {
    optional: true,
    label: 'Автор',
    nested: UserFindDto,
    serializer: (_, nested) => nested,
  },
  name: {
    sortable: true,
    label: 'Название',
    serializer: yup.string(),
  },
});
